// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__2Uf-6","backContainer":"styles_backContainer__2zh1Y","buy":"styles_buy__1N1U7","titleHeader":"styles_titleHeader__AdQ1C","text":"styles_text__3nWg6"};